/**
 * Supported keys for local storage read/write.
 *
 * Please do not forget to add a getter/setter for each of the keys define here in {@link MKLocalStorage}
 *
 * @internal
 */
export enum MKLocalStorageKeys {
    /**
     * Unique device identifier.
     */
    DeviceId = "deviceid",

    /**
     * Device profile.
     */
    DeviceProfile = "deviceprofile",

    /**
     * Is registered?
     */
    Registered = "registered",

    /**
     * Beacons data.
     */
    BeaconData = "beacondata",

    /**
     * private key.
     */
    ClientKeys = "clientkeys"
}